import React from 'react';
import PropTypes from 'prop-types';

export default function ASocialMedia({
	img,
	alt,
	href,
	className,
}) {
	return (
		<a href={href} target="_blank">
			<figure className={`a-social-media ${className}`}>
				<img src={img} alt={alt} />
			</figure>
		</a>
	);
}


ASocialMedia.propTypes = {
	img: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.social-media.js